import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Calendar, Trophy, FolderOpen, LayoutDashboard, UserPlus } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const { user } = useAuth();

  const navItems = [
    { path: '/feed', label: 'Feed', icon: Home },
    { path: '/success-stories', label: 'Success Stories', icon: Trophy },
    { path: '/resources', label: 'Resources', icon: FolderOpen },
    { path: '/directory', label: 'Members', icon: Users },
    { path: '/network', label: 'My Network', icon: UserPlus },
    { path: '/events', label: 'Events', icon: Calendar },
  ];

  if (user?.is_admin) {
    navItems.push({ path: '/admin', label: 'Admin Panel', icon: LayoutDashboard });
  }

  const isActive = (path) => location.pathname === path;

  return (
    <aside className="hidden lg:block" data-testid="sidebar">
      <div className="bg-white rounded-md border border-slate-100 shadow-sm p-4">
        <nav className="space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive(item.path)
                    ? 'text-[#1E3A8A] bg-blue-50'
                    : 'text-slate-600 hover:text-[#1E3A8A] hover:bg-slate-50'
                }`}
                data-testid={`sidebar-${item.label.toLowerCase().replace(' ', '-')}`}
              >
                <Icon className="h-5 w-5" />
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
